import { createSlice } from "@reduxjs/toolkit"

const initialState = { oldhistory: '/' }

const historySlice = createSlice({
    name: "history",
    initialState,
    reducers: {
        sethistory: (state, action) => {
            state.oldhistory = action.payload
        },
        clearhistory: (state) => {
            state.oldhistory = '/'
        }
    }
})

export const { sethistory, clearhistory } = historySlice.actions;
export default historySlice.reducer;